import type {
	useTabsHooksPropsType,
	useTabsHookType,
} from "Shared/Components/Tabs/Types/TabType";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

export const useNavigateTabs: (args: useTabsHooksPropsType) => useTabsHookType =
	({ tabs, currentTab }) => {
		const [activeTab, setActiveTab] = useState(currentTab);
		const navigate = useNavigate();

		useEffect(() => {
			setActiveTab(currentTab);
		}, [currentTab]);

		return {
			active: activeTab,
			onChange: (_, index: string) => {
				const path = tabs.find((tab) => tab.index === index)?.path;
				path && navigate(path);
			},
		};
	};
